import React from 'react';
import { ColumnsFactory } from "../../../../../../shared/components/Grid/functions";
import { Link } from 'react-router-dom';

export const getColumnDefs = () => {

  const LinkCell = (params) =>{
    return <Link to={{
      pathname: "/Validaciones",
      search: "",
      state: { 
        // filter:{
        //   sociedad:{
        //     filterType: 'text',
        //     type: 'contains',
        //     filter: 'ALEMANIA'//params.data.idDN
        //   }
        // } 
      }
    }}>{params.value}</Link>
  }

  return [
    ColumnsFactory.TextColumn("Cod. DN/SG", "idDN"),
    ColumnsFactory.TextColumn("DN/SG", "direccionNegocio"),
    ColumnsFactory.DecimalColumn("Horas Control", "nHorasControl", {ipkTotalizar: true}),
    ColumnsFactory.DecimalColumn("Horas Utilidad", "nHorasUtilidad", {ipkTotalizar: true}),
    ColumnsFactory.DecimalColumn("Total Horas", "nHorasTotal", {ipkTotalizar: true, cellRendererFramework: LinkCell})
  ];
};